module.exports = __webpack_public_path__ + "img/H10.b6c9779b.jpg";